import React from "react";
import IconClose from "../dynamicicons/icon-close";
import VelavuIconButton from "./velavu-icon-button";
import * as styles from "./velavu-titled-modal.module.scss";
import VelavuModalContainer from "./velavu-modal-container";
import { classArr } from "../helper/style-helper";
import whitelabel from "../whitelabel";

export type VelavuTitledModalSize = "wrap" | "fill";

export interface VelavuTitledModalProps {
	title: string;
	onClose: VoidFunction;
	size?: VelavuTitledModalSize;
	children?: React.ReactNode;
}

//Use as the root element of a modal to add a title and close button
export function VelavuTitledModal(props: VelavuTitledModalProps) {
	const { title, onClose, size = "wrap", children } = props;

	return (
		<VelavuModalContainer
			className={classArr(props.size === "fill" && styles.fill)}
		>
			<div className={styles.dialogHeader}>
				<span className={styles.dialogTitle}>{title}</span>
				<VelavuIconButton onClick={onClose}>
					<IconClose color={whitelabel.palette.secondary500} />
				</VelavuIconButton>
			</div>
			<div className={styles.dialogContent}>{children}</div>
		</VelavuModalContainer>
	);
}
